import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import UmbrellaOutlinedIcon from '@mui/icons-material/UmbrellaOutlined'
import { SectionDefinition } from '../../../components/Sections/Sections.types'

export enum ConditionalStatusSectionIds {
  general = 'general',
  conditions = 'conditions',
}

/**
 * @description Sections shared by the Conditional Status detail page and edit form, in display order.
 */
export const conditionalStatusSections: SectionDefinition[] = [
  {
    id: ConditionalStatusSectionIds.general,
    title: 'General',
    description: 'Group, resulting trail status, and the order this rule is matched in.',
    icon: InfoOutlinedIcon,
  },
  {
    id: ConditionalStatusSectionIds.conditions,
    title: 'Conditions',
    description: 'The precipitation and lookback window that must match for this status to apply.',
    icon: UmbrellaOutlinedIcon,
  },
]
